import axios from "axios";
import { getToken } from "firebase/messaging";
import { messaging } from "../../config/firebase";

const API_BASE_URL =
  import.meta.env.VITE_BASE_URL_API_BACKEND ||
  import.meta.env.VITE_API_BASE_URL ||
  "http://localhost:4000/api/v1";

export default class NotificationService {
  /** filter: all | visible | unread | liked | hidden; before: id da última já carregada. */
  static getUserNotifications = async (idToken, { filter, before } = {}) => {
    return axios.get(`${API_BASE_URL}/notifications`, {
      params: { filter, before },
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
  };

  static getDeviceToken = async () => {
    return await getToken(messaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
    });
  };

  static getBrowser = () => {
    const ua = navigator.userAgent;

    if (ua.includes("Edg")) return "Edge";
    if (ua.includes("Firefox")) return "Firefox";
    if (ua.includes("Chrome")) return "Chrome";
    if (ua.includes("Safari")) return "Safari";

    return "Unknown";
  };

  static registerDeviceToken = async (idToken) => {
    const token = await this.getDeviceToken();

    if (!token) return;

    return axios.post(
      `${API_BASE_URL}/notifications/devices`,
      {
        token,
        platform: navigator.userAgentData?.platform || navigator.platform,
        browser: this.getBrowser(),
      },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    );
  };

  static getLatestNotifications = async (afterId, idToken) => {
    const { data } = await axios.get(
      `${API_BASE_URL}/notifications/latest?afterId=${afterId}`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    );

    return data.data;
  };

  static markNotificationAsRead = async (notificationId, idToken) => {
    return await axios.patch(
      `${API_BASE_URL}/notifications/${notificationId}/read`,
      {},
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    );
  };

  static markAllNotificationsAsRead = async (idToken) => {
    return await axios.patch(
      `${API_BASE_URL}/notifications/read-all`,
      {},
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    );
  };

  static updateNotificationReaction = async (
    notificationId,
    reaction,
    idToken,
  ) => {
    return axios.patch(
      `${API_BASE_URL}/notifications/${notificationId}/reaction`,
      { reaction },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    );
  };

  static updateNotificationVisibility = async (
    notificationId,
    isHidden,
    idToken,
  ) => {
    return axios.patch(
      `${API_BASE_URL}/notifications/${notificationId}/visibility`,
      {
        is_hidden: isHidden,
      },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    );
  };

  static getUnreadSummary = async (idToken) => {
    const { data } = await axios.get(
      `${API_BASE_URL}/notifications/unread-summary`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    );

    return data.data;
  };

  static getNotificationCounts = async (idToken) => {
    const { data } = await axios.get(`${API_BASE_URL}/notifications/counts`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });

    return data.data;
  };
}
